import * as React from 'react';
import type { SVGProps } from 'react';
const SvgOrder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={46}
    height={50}
    fill="none"
    {...props}
  >
    <path
      fill="#F5365C"
      stroke="#F5365C"
      strokeWidth={1.24}
      d="M10.605 39.787c-.768.592-.375 1.88.637 1.88h32.636a.872.872 0 1 1 0 1.743H39.34l.348.854c.137.338.223.804.223 1.273 0 2.119-1.738 3.842-3.887 3.842-2.148 0-3.886-1.727-3.886-3.846 0-.468.085-.93.223-1.27l.347-.852h-9.994l.348.853c.137.338.223.804.223 1.273 0 2.119-1.738 3.842-3.887 3.842-2.148 0-3.886-1.727-3.886-3.846 0-.468.085-.93.223-1.27l.347-.852h-4.839c-2.593 0-3.764-3.438-1.704-5.026l4.188-3.225.317-.245-.092-.39L7.377 6.71l-.112-.477H2.12a.872.872 0 1 1 0-1.743h5.811c.406 0 .748.265.845.643l1.37 5.321.101.398.407.06 3.58.537a.874.874 0 0 1-.258 1.73h-.002l-2.39-.349-.898-.13.204.883 4.71 20.361.11.48h25.773c.6 0 1.038-.505 1.048-1.042l.291-14.98a1.047 1.047 0 0 0-.892-1.054.87.87 0 1 1 .258-1.72 2.803 2.803 0 0 1 2.38 2.816l-.292 14.971c-.03 1.51-1.288 2.753-2.792 2.753H15.316l-.167.128-4.543 3.492Zm6.651 5.73c0 1.176.972 2.111 2.141 2.111 1.17 0 2.141-.935 2.141-2.111 0-1.177-.971-2.112-2.14-2.112-1.17 0-2.142.935-2.142 2.111Zm16.626 0c0 1.176.971 2.111 2.141 2.111s2.141-.935 2.141-2.111c0-1.177-.971-2.112-2.141-2.112s-2.14.935-2.14 2.111Z"
    />
    <path
      fill="#F5365C"
      stroke="#F5365C"
      strokeWidth={1.24}
      d="M27.92 21.138c-5.636 0-10.22-4.573-10.22-10.189S22.285.76 27.92.76c5.637 0 10.22 4.573 10.22 10.19 0 5.615-4.583 10.188-10.22 10.188Zm0-18.635c-4.67 0-8.474 3.786-8.474 8.446s3.803 8.446 8.474 8.446c4.672 0 8.475-3.786 8.475-8.446s-3.803-8.446-8.475-8.446Z"
    />
    <path
      stroke="#F5365C"
      strokeLinecap="round"
      strokeWidth={3.399}
      d="M24.133 10.906h6.799"
    />
  </svg>
);
export default SvgOrder;
